import { render, staticRenderFns } from "./pointInfo.vue?vue&type=template&id=bc83c136&scoped=true&"
import script from "./pointInfo.vue?vue&type=script&lang=js&"
export * from "./pointInfo.vue?vue&type=script&lang=js&"
import style0 from "./pointInfo.vue?vue&type=style&index=0&id=bc83c136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc83c136",
  null
  
)

export default component.exports